import {Constants} from "../../constants";
import {Routes} from "@angular/router";
import {UserRolesGuard} from "../../route-guards/user-roles.guard";
import {AnalyzerResultsComponent} from "./analyzer-results.component";

export const SKIN_ANALYZER_ROUTES: Routes = [
    {
        path: ':locale',
        canActivateChild: [UserRolesGuard],
        children: [
            {
                path: Constants.SKIN_ANALYZER_RESULTS_STATE,
                component: AnalyzerResultsComponent,
                data: {
                    roles: [Constants.ROLES.ASSOCIATE, Constants.ROLES.PC, Constants.ROLES.EMPLOYEE, Constants.ROLES.AFFILIATE],
                    restrict: [Constants.ROLES.NFR, Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.CBEC, Constants.ROLES.EVENT]
                }
            },
        ]
    }
];
